import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Highlighter } from '../Highlighter/index.js';
/**
 * 已翻译单词高亮UI组件
 */
export const TranslatedWordHighlighter = ({ segments, onHighlightHover, onHighlightLeave, loading = false, originalText = '', highlightColor = 'rgba(52, 211, 153, 0.3)', className = '', dataTestId = 'paragraph-content', }) => {
    if (loading) {
        return _jsx("div", { className: `text-paragraph ${className}`, children: originalText });
    }
    return (_jsx(_Fragment, { children: _jsx(Highlighter, { segments: segments, highlightColor: highlightColor, onHighlightHover: onHighlightHover, onHighlightLeave: onHighlightLeave, className: className, dataTestId: dataTestId }) }));
};
export default TranslatedWordHighlighter;
//# sourceMappingURL=TranslatedWordHighlighter.js.map